<template>

    <OverlayPanel ref="op" :showCloseIcon="false" :dismissable="true">
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-lg-12">
                <div class="card card-w-title">
                    <h1>{{ $t('userPreference.title') }}</h1>
                    <div class="p-col-12 p-lg-12">
                        <InputSwitch key="colorMenu" @click="changeLayoutColor()" class="aling" v-model="layoutColorMode" /> <div class="p-col-9 p-lg-9 dv-darkmode">{{ $t('userPreference.colorMode') }}</div>
                    </div>
                    <div class="p-col-12 p-lg-12">
                        <InputSwitch key="staticMenu" @click="changeStaticMenu()" class="aling" v-model="staticMenu" /> <div class="p-col-9 p-lg-9 dv-darkmode">{{ $t('userPreference.menuMode') }}</div>
                    </div>
                    <h3>{{ $t('userPreference.language') }}</h3>
                    <div class="p-col-12 p-lg-12">
                        <a href @click.prevent="changeLanguage('en-US')" ><span class="flag-icon flag-icon-us flag-icon-large"></span><span>{{ $t('userPreference.languages.gb') }}</span></a>
                    </div>
                    <div class="p-col-12 p-lg-12">
                        <a href @click.prevent="changeLanguage('pt-BR')" ><span class="flag-icon flag-icon-br flag-icon-large"></span><span>{{ $t('userPreference.languages.br') }}</span></a>
                    </div>
                    <h3 v-if="loggedUser.typeUser === administrator"><router-link :to="{name : 'system-configuration'}"><i class="pi pi-cog"></i> {{ $t('userPreference.system-configuration') }}</router-link></h3>
                </div>
            </div>
        </div>
    </OverlayPanel>

</template>

<script>

    import store from "@/store.js";
    import EventBus from "@/commons/EventBus.js";
    import {ADMINISTRATOR} from "@/constants/TypeUser";

    export default {
        name: "UserPreferences",

        props:{
            reference: null,
        },

        data(){
            return {
                administrator: ADMINISTRATOR,
                loggedUser: store.getLoggedUser(),
                layoutColorMode: true,
                staticMenu: null,
                dark: 'dark',
                light: 'light',
                static: 'static',
                overlay: 'overlay',
            }
        },

        mounted(){
            this.layoutColorMode = store.getLayoutColor() === this.dark ? true : false;
            this.staticMenu = store.getStaticMenu() === this.static ? true : false;
            this.$refs.op.toggle(this.reference);
        },

        methods: {

            changeLayoutColor(){
                store.setLayoutColor(!this.layoutColorMode ? this.dark : this.light);
                EventBus.$emit('LAYOUT_COLOR');
            },

            changeStaticMenu(){
                store.setStaticMenu(!this.staticMenu? this.static : this.overlay);
                EventBus.$emit('STATIC_MENU');
            },

            changeLanguage(language){
                this.$i18n.locale = language;
                store.setLanguage(language);
            }

        }

    }
</script>

<style scoped>
    @import "~flag-icon-css/css/flag-icon.css";

    body .p-overlaypanel {
        position: fixed !important;
        display: block !important;
        left: 1040px;
    }

    .p-overlaypanel:before {
        margin-left: 275px!important;
        border-left-width: 10px!important;
    }

    .p-overlaypanel:after{
        margin-left: 277px!important;
    }

    .dv-darkmode {
        float: right;
        margin-top: 2px;
    }

    .aling {
        margin-top: 6px;
    }

    .flag-icon-large {
        margin-right: 10px;
        width: 31px;
        height: 23px;
    }

</style>
